import {MontantAnnuel} from './MontantAnnuel';
import {TypeAdresseCompleteMorale} from './TypeAdresseCompleteMorale';
import {TypeMontant} from './TypeMontant';
import {SousTraitanceOui} from './SousTraitanceOui';
import {Offres} from './Offres';
export class TypeAttributionMarcheLot {

	public montantAnnuel: MontantAnnuel;

	public montantIndefini: string;

	public trancheFerme: string;

	public trancheConditionnelle: string;

	public titulaire: TypeAdresseCompleteMorale;

	public sousTraitanceOui: SousTraitanceOui;

	public offres: Offres;

	public montant: TypeMontant;

	public sousTraitanceNon: string;

	public isSousTraitance: boolean

	constructor() {
		 		this.montantAnnuel = new MontantAnnuel();
		this.montantIndefini = null;
		this.trancheFerme = '';
		this.trancheConditionnelle = null;
		this.titulaire = new TypeAdresseCompleteMorale();
		this.sousTraitanceOui = new SousTraitanceOui();
		this.offres = new Offres();
		this.montant = new TypeMontant();
		this.sousTraitanceNon = null;
		this.isSousTraitance = true;

	}
}
